export const BRANCH_OPERATING_DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

/**
 * 後端可能回傳 null 或缺日：補齊七日結構，避免讀取 .sun 等噴錯。
 */
export function normalizeBranchOperatingHours(hours) {
    const next = {};
    BRANCH_OPERATING_DAY_KEYS.forEach((d) => {
        const day = hours && typeof hours === 'object' ? hours[d] : null;
        const rawTime = day && Array.isArray(day.time) ? day.time : [];
        const time =
            rawTime.length > 0
                ? rawTime.map((slot) =>
                    Array.isArray(slot) && slot.length >= 2
                        ? [String(slot[0]), String(slot[1])]
                        : ['00:00', '00:00']
                )
                : [['00:00', '00:00']];
        next[d] = {
            open: !!(day && day.open),
            time,
        };
    });
    return next;
}
